import { render } from "./post-smtp-header.vue?vue&type=template&id=65055dc1&scoped=true"
import script from "./post-smtp-header.vue?vue&type=script&lang=js"
export * from "./post-smtp-header.vue?vue&type=script&lang=js"

import "./post-smtp-header.vue?vue&type=style&index=0&id=65055dc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65055dc1"]])

export default __exports__